//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { ActionBase, Illustration } from '@backmarket/design-system'

import { COMPANY_NAME } from '@config/constants'
import { ROUTES } from '@router'

import BmLogo from './BM_logo.svg'

const GIF_SOURCE = '/img/logo_animated_bm.gif'

export default {
  components: {
    ActionBase,
    Illustration,
    BmLogo,
  },
  props: {
    // We use this logo on all headers (funnel, minimal, main)
    // We don't want the animated logo everywhere for now
    // so we need to use this props
    hasAnimation: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      gifSource: GIF_SOURCE,
    }
  },
  computed: {
    COMPANY_NAME: () => COMPANY_NAME,
    ROUTES: () => ROUTES,
    isHomePage() {
      return this.$route.name === ROUTES.HOME
    },
  },
  beforeDestroy() {
    clearTimeout(this.delay)
  },
  methods: {
    // We use this tricky method to reset gif animation on mouse out
    resetGifSource() {
      clearTimeout(this.delay)
      this.delay = setTimeout(() => {
        this.gifSource = `${GIF_SOURCE}?x=${1 * Math.random()}`
      }, 300)
    },
  },
}
